export default "__VITE_ASSET__DzgA7Itr__"